






















import { Component, Vue } from "vue-property-decorator";
import { getId, getRouteName } from '@/config/cookies'
import { updateReceipt } from '@/api/interface'
import { uploadVoucher } from '@/api/factory'
import { telPattern, truckPattern } from '@/config'
import { compress, ratios } from '@/config/utils'
@Component
export default class extends Vue {
    private form: updateReceipt = {
        openId: '',
        order_no: '',
        app_order_id: 0,
        urlName: '',
        factory_id: 0,
    }
    private async getPhotos(file: any) {
	  (this.$refs.frontPhotos as any).src = file.content
		let ratio = ratios(file.file.size)
		let str = await compress(file.content, ratio)
		this.form.urlName = str
    }
    
    private async onSubmit() {
		let res: any = await uploadVoucher(this.form)
		if(res.status == '1') {
			this.$notify({ type: "success", message: "上传成功" });
			this.$router.replace({name: 'orderSummary'})
			// if(getRouteName()) this.$router.replace({name: getRouteName()})
		}else{
			this.$notify({ type: "danger", message: res.info });
		}
	}
	private mounted() {
        console.log(this.$route.query, 'aaa')
        this.form = Object.assign({},this.form, this.$route.query)
        this.form.openId = getId()
	}
}
